import { useAuth } from "@/AuthContext";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useAuth();
  return (
    <div className={`inline-flex items-center gap-1 text-sm ${className}`} data-testid="lang-toggle">
      <button
        onClick={() => setLang("de")}
        className={`px-2 py-1 rounded-md transition ${lang === "de" ? "text-pine font-semibold" : "text-ink-muted hover:text-ink"}`}
        data-testid="lang-de-btn"
      >DE</button>
      <span className="text-ink-muted/50">·</span>
      <button
        onClick={() => setLang("en")}
        className={`px-2 py-1 rounded-md transition ${lang === "en" ? "text-pine font-semibold" : "text-ink-muted hover:text-ink"}`}
        data-testid="lang-en-btn"
      >EN</button>
    </div>
  );
}
